import { render, staticRenderFns } from "./UnifiedCashier.vue?vue&type=template&id=2d322961&scoped=true&"
import script from "./UnifiedCashier.vue?vue&type=script&lang=js&"
export * from "./UnifiedCashier.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedCashier.vue?vue&type=style&index=0&id=2d322961&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d322961",
  null
  
)

export default component.exports